export default __webpack_public_path__ + "static/media/header3.d79b8f44.jpg";